import { IconStudioDisplay } from 'central-icons/IconStudioDisplay';

import { useBrand } from '../shared/branding/brand-provider';
import styles from './MobileUnsupportedPage.module.css';

export const MobileUnsupportedPage = () => {
  const brand = useBrand();
  const BrandFullLogo = brand.logos.fullLogo;
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <BrandFullLogo className={styles.logo} />
        <h1 className={styles.title}>
          This experience is best on larger screens
        </h1>
        <p className={styles.description}>
          At this time, Revelio Labs is best experienced on desktop and larger
          screens to give you the full power of our analytics platform.
        </p>
        <svg
          className={styles.glyph}
          viewBox="0 0 131 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect
            x="3"
            y="3"
            width="125"
            height="86"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path d="M48 89v17h35V89" stroke="currentColor" strokeWidth="6" />
        </svg>
        <div className={styles.card}>
          <IconStudioDisplay size={34} className={styles.cardIcon} />
          <div className={styles.cardText}>
            <p className={styles.cardTitle}>For the best experience</p>
            <p className={styles.cardBody}>
              Please visit us on a laptop or desktop computer.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
